import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthApi from 'api/AuthApi';

export const logoutThunk = (authApi: AuthApi) =>
  createAsyncThunk('account/Logout', async () => {
    try {
      return await authApi.logout();
    } catch (error: any) {
      throw error;
    }
  });
